import KeplerBackofficeSdk from './../../lib/kepler/backoffice.js'

const state = {
  company: null,
  branding: null,
  locale: null,
  constraints: null,
  commercial: null,
  fleet: null,
  communication: null,
  system: null,
  application: null,
  userConfiguration: null,
  configReady: false,
  vats: [],
  commonCostTypes: []
}

const mutations = {
  SET_CONFIG(state, payload) {
    Object.assign(state, payload)
  },
  SET_USER_CONFIG(state, payload) {
    state.userConfiguration = payload
    let permissions = {}
    payload.permissions.forEach((item) => {
      //console.log(item)
      let path = ''
      switch (item) {
        case'index-clients':
          path = 'clients'
          break
        case'index-drivers':
          path = 'drivers'
          break
        case'index-reservations':
          path = 'reservations'
          break
        case'index-plan':
          path = 'plans'
          break
        case'index-reporting':
          path = 'reportings'
          break
      }

      permissions[path] = item
    })

    state.userConfiguration.permissions = permissions
  },
  SET_CONFIG_READY(state, payload) {
    state.configReady = payload
  },
  SET_VATS(state, payload) {
    state.vats = payload
  },
  SET_COMMON_COST_TYPES(state, payload) {
    state.commonCostTypes = payload
  },
}

const actions = {
  init() {
    this.dispatch('getConfiguration')
    this.dispatch('loadVat')
    this.dispatch('loadCommonCostTypes')
  },
  configInit() {
    return this.dispatch('getUserConfiguration').then(() => {
      return this.dispatch('getConfiguration')
    })
  },
  getConfiguration: ({commit}) => {

    return KeplerBackofficeSdk.configuration.getPromise().then(
      (payload) => {
        commit('SET_CONFIG', payload.data)
        commit('SET_CONFIG_READY', true)
        return payload.data
      }
    )
  },
  getUserConfiguration: ({commit}) => {
    return KeplerBackofficeSdk.userConfig.list().then((payload) => {
      commit('SET_USER_CONFIG', payload.data)
      return payload.data
    })
  },
  loadVat: ({commit}) => {
    return KeplerBackofficeSdk.vats.list(1, -1).all((data) => {
      commit('SET_VATS', data.items)
    })
  },
  loadCommonCostTypes:  ({commit}) => {
    KeplerBackofficeSdk.commonCostType.list.all(1,25,(data) => {
      commit('SET_COMMON_COST_TYPES', data.items)
    })
  }
}

export default {
  state, mutations, actions
}



// WEBPACK FOOTER //
// ./src/store/backoffice/configuration.js